import { data } from "jquery"

class Video {
    constructor(props) {
        this.props = props
        this.props.icon = props.icon || '.icon'
        this.props.iconPlay = props.iconPlay || 'icon-play'
        this.props.iconPause = props.iconPause || 'icon-pause'
        this.props.iconMute = props.iconMute || 'icon-volume-mute'
        this.props.iconVolumeUp = props.iconVolumeUp || 'icon-volume-up'
        this.props.windowWidth = window.innerWidth
        this.init()
    }
    init() {
        if ( typeof this.props.elem === 'undefined' ) return
        this.videoWrapper = document.querySelector(this.props.elem)
        
        if (!this.videoWrapper) return
        if ( this.videoWrapper.classList.contains('embed') ) {
            this.setIframeSrc()
        } else {
            this.video = this.videoWrapper.querySelector('video')
            this.playPauseButton = this.videoWrapper.querySelector(this.props.playPause)
            this.soundButton = this.videoWrapper.querySelector(this.props.sound)
            this.setSource()
            this.addToggleControl()
            this.addToggleSound()
            
            // add play p
            this.eventPlayPause()
            
            // add mouse stop
            this.hideControl()
        }
        this.initWindowResize()
    }
    initWindowResize() {
        window.addEventListener('resize', _.debounce(() => {
            if ( window.innerWidth != this.props.windowWidth ) {
                if ( this.videoWrapper.classList.contains('embed') ) {
                    this.setIframeSrc()
                } else {
                    this.setSource()
                }
            }
        }, 250))
    }
    setIframeSrc() {
        const iframe = document.querySelector('#embedVideo')
        const srcDt = iframe.dataset.srcDt
        const srcMb = iframe.dataset.srcMb
        if (window.innerWidth < 767 ) {
            iframe.setAttribute('src', srcMb)
        } else {
            iframe.setAttribute('src', srcDt)
        }
    }
    setSource() {
        this.video.pause()
        this.video.currentTime = 0
        
        this.video.innerHTML = ''
        const source = document.createElement('source')
        const srcDt = this.video.dataset.srcDt
        const srcTb = this.video.dataset.srcTb
        const srcMb = this.video.dataset.srcMb
        if (window.innerWidth < 768 ) {
            if ( srcMb ) {
                source.setAttribute('src', srcMb)
            } else {
                source.setAttribute('src', srcDt)
            }
        } else if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
            if ( srcTb ) {
                source.setAttribute('src', srcTb)
            } else {
                source.setAttribute('src', srcDt)
            }
        } else {
            source.setAttribute('src', srcDt)
        }
        source.setAttribute('type', 'video/mp4')
        this.video.prepend(source)
        this.video.load()
        if ( this.video.getAttribute('autoplay') ) {
            this.video.play()
        }
    }
    createToggleControl() {
        this.buttonWrapper = document.createElement('div')
        this.buttonWrapper.classList.add('button-wrapper')
        this.playPauseButton = document.createElement('button')
        this.playPauseButton.type = 'button'
        this.playPauseButton.classList.add('icon-control', )
    }
    addToggleControl() {
        this.playPauseButton.addEventListener('click', () => {
            
            if(this.video.paused) {
                this.video.play();
            } else {
                this.video.pause();
            }
        })
    }
    
    addToggleSound() {
        this.soundButton.addEventListener('click', () => {
            if(this.video.muted) {
                this.video.muted = false
                this.soundButton.classList.remove('mute')
                this.soundButton.classList.add('volume-up')
            } else {
                this.video.muted = true
                this.soundButton.classList.add('mute')
                this.soundButton.classList.remove('volume-up')
            }
        })
    }
    eventPlayPause() {
        this.video.addEventListener('play', () => {
            this.playPauseButton.classList.add('pause')
            this.playPauseButton.classList.remove('play')
            
        })
        
        this.video.addEventListener('pause', () => {
            this.playPauseButton.classList.add('play')
            this.playPauseButton.classList.remove('pause')
            
        })
    }
    hideControl() {
        let i = null;
        
        this.videoWrapper.addEventListener('mousemove', () => {
            clearTimeout(i)
            let buttonWrapper = this.playPauseButton.parentNode
            buttonWrapper.classList.add('show')
            i = setTimeout(() => {
                buttonWrapper.classList.remove('show')
            }, 3000)
        })
    }
    onPlayerReady(event) {
        event.target.playVideo()
    }
    onPlayerStateChange(event) {
        if (event.data == this.YT.PlayerState.PLAYING && !this.done) {
            setTimeout(() => {
                this.stopVideo()
            }, 6000)
            this.done = true
        }
    }
    stopVideo() {
        this.player.stopVideo();
    }
}
export default Video